import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { getSupabase } from "@/lib/hooks/api/utils";

export function useCreateContactFile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (fileData: {
      name: string;
      contact_id: string;
      url: string;
      type?: string;
      size?: number;
      description?: string;
      tags?: string[];
    }) => {
      const supabase = getSupabase();
      const {
        data: { user },
      } = await supabase.auth.getUser();

      if (!user) {
        throw new Error("User not authenticated");
      }

      const { data, error } = await supabase
        .from("contact_files")
        .insert([
          {
            ...fileData,
            user_id: user.id,
          },
        ])
        .select()
        .single();

      if (error) {
        console.error("Error creating contact file:", error);
        throw new Error(error.message);
      }

      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["contact-files"] });
      toast.success("File uploaded successfully");
    },
    onError: (error) => {
      toast.error("Failed to upload file");
      console.error("Error creating contact file:", error);
    },
  });
}
